module.exports = __webpack_public_path__ + "img/huhaibo.887e7271.jpg";